import { ValidationRulePreset } from 'common/Validator/ValidationRules';
import { createImmutableFormValidatorConfig, FormValidatorConfig } from 'common/Validator/Validator';

import { URGENT_DETAILS_OPTIONS } from './survey-options';

interface SurveyFormParams {
  urgent: boolean | null;
  urgentDetails?: string;
}

export const SURVEY_VALIDATOR_CONFIG: FormValidatorConfig<SurveyFormParams> = createImmutableFormValidatorConfig([
  {
    field: 'lastVisited',
    preset: ValidationRulePreset.required,
  },
  {
    field: 'anxiety',
    preset: ValidationRulePreset.required,
  },
  {
    field: 'urgent',
    preset: ValidationRulePreset.required,
  },
  {
    field: 'treatments',
    preset: ValidationRulePreset.required,
    shouldIgnore: ({ urgent }) => urgent === true,
  },
  {
    field: 'urgentDetails',
    preset: ValidationRulePreset.required,
    shouldIgnore: ({ urgent }) => urgent === false,
  },
  {
    field: 'urgentDetailsOther',
    preset: ValidationRulePreset.required,
    shouldIgnore: ({ urgentDetails }) => urgentDetails !== URGENT_DETAILS_OPTIONS.find((option) => option.id === 'other')?.id,
  },
]);
